const infoHeadTitleList: any[] = [
  {
    headTitle: "年度",
  },
  {
    headTitle: "区分",
  },
  {
    headTitle: "掛金",
  },
  {
    headTitle: "納付金額",
  },
  {
    headTitle: "掛金収納状態",
  },
  {
    headTitle: "割増金",
  },
  {
    headTitle: "納付金額",
  },
  {
    headTitle: "割増金収納状態",
  },
];

export { infoHeadTitleList };
